import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToElement } from "@/lib/scrollUtils";

/**
 * Global component that handles scroll behavior on route changes.
 * Standardizes hash scrolling and scroll-to-top across the entire application.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const targetId = hash.replace("#", "");
      
      const attemptScroll = () => {
        // Use standardized utility for consistent offset
        const found = scrollToElement(targetId);
        return found;
      };

      // Try with exponential backoff to handle lazy loading
      let attempts = 0;
      const maxAttempts = 10;
      
      const tryScroll = () => {
        if (!attemptScroll() && attempts < maxAttempts) {
          attempts++;
          const delay = Math.min(100 * Math.pow(1.5, attempts), 2000);
          setTimeout(tryScroll, delay);
        }
      };

      // Initial small delay to let the page start rendering
      const timeoutId = setTimeout(tryScroll, 150);
      return () => clearTimeout(timeoutId);
    } else {
      // Smooth scroll to top when changing page without hash
      window.scrollTo({
        top: 0,
        behavior: "instant" // Use instant to avoid weird smooth scroll from previous page position
      });
    }
  }, [pathname, hash]);

  return null;
}


